/**
 * Dashboard Options
 *
 * Shared constants for time range and refresh interval options
 * used across widget configuration and global override dropdowns.
 */

// Time range options for widget configuration
export const TIME_RANGE_OPTIONS = [
  { value: '1h', label: 'Last Hour' },
  { value: '6h', label: 'Last 6 Hours' },
  { value: '24h', label: 'Last 24 Hours' },
  { value: '7d', label: 'Last 7 Days' },
  { value: '30d', label: 'Last 30 Days' },
  { value: '180d', label: 'Last 6 Months' },
  { value: '365d', label: 'Last 12 Months' },
  { value: 'all', label: 'All Time' }
]

// Refresh interval options (in seconds) for widget configuration
export const REFRESH_INTERVAL_OPTIONS = [
  { value: 60, label: '1 minute' },
  { value: 300, label: '5 minutes' },
  { value: 900, label: '15 minutes' },
  { value: 1800, label: '30 minutes' },
  { value: 3600, label: '1 hour' }
]

// For global override dropdowns (includes "Per Widget" option)
export const GLOBAL_TIME_RANGE_OPTIONS = [
  { value: 'per_widget', label: 'Per Widget' },
  ...TIME_RANGE_OPTIONS
]

export const GLOBAL_REFRESH_INTERVAL_OPTIONS = [
  { value: 'per_widget', label: 'Per Widget' },
  ...REFRESH_INTERVAL_OPTIONS.map(o => ({ value: String(o.value), label: o.label }))
]

// Default values
export const DEFAULT_TIME_RANGE = '24h'
export const DEFAULT_REFRESH_INTERVAL = 300
